import { createSelector } from 'reselect';

const selectDomain = (state) => state.cards;

export const selectCardsById = createSelector(
  [selectDomain], (state) => state.get('cardsById'),
);

/** Every card of every set (the card lookup), by id, or null until loaded. */
export const selectAllCards = createSelector(
  [selectDomain], (state) => state.get('allCards'),
);

export const selectCardsLoaded = createSelector(
  [selectDomain], (state) => state.get('cardsLoaded'),
);
